"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "FRIDAY": "Vineri",
    "MONDAY": "Luni",
    "SATURDAY": "Sâmbătă",
    "SUNDAY": "Duminică",
    "THURSDAY": "Joi",
    "TUESDAY": "Marţi",
    "WEDNESDAY": "Miercuri",
    "and": "și",
    "day_few": "zile",
    "day_one": "zi",
    "day_other": "zile",
    "day_plural": "zile",
    "freeOfCharge": "Gratuit",
    "hour_one": "ora",
    "hour_one_plural": "ore",
    "hour_other": "ore",
    "minute_few": "minut",
    "minute_one": "minut",
    "minute_other": "minute",
    "ocpiRestrictionsAfterDuration": "După {{minDuration}}",
    "ocpiRestrictionsBetweenDuration": "Între {{minDuration}} și {{maxDuration}}",
    "ocpiRestrictionsFirstDuration": "Primul {{maxDuration",
    "ocpiRestrictionsKwhAbove": "Când consumul de energie depășește {{minKwh}}",
    "ocpiRestrictionsKwhBetween": "Când consumul de energie este între {{minKwh}} și {{maxKwh}}",
    "ocpiRestrictionsKwhLessThan": "Când consumul de energie este mai mic de {{maxKwh}}",
    "session": "sesiune",
    "theDay_few": "zi",
    "theDay_one": "zi",
    "theDay_other": "zile",
    "theHour_few": "ora",
    "theHour_one": "ora",
    "theHour_other": "ore",
    "theMinute_few": "minut",
    "theMinute_one": "minut",
    "theMinute_other": "minute"
};
